module.exports = __webpack_public_path__ + "img/icon_tt_plus.5a48b2fb.svg";